import { render, staticRenderFns } from "./creation.vue?vue&type=template&id=64572c4c&"
import script from "./creation.vue?vue&type=script&lang=js&"
export * from "./creation.vue?vue&type=script&lang=js&"
import style0 from "./creation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports